// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"54":"315e144f84fd8bf6","469":"a6bf3c0e0bf39596","958":"c68cbcc0b8a03a6e"}[chunkId] + ".js";
};